import { LogLevel } from "@azure/msal-browser";

const windowInfo = (window as any).config.auth;

export const msalConfig = {
    auth: {
        clientId: windowInfo.clientId,
        authority: windowInfo.authority,
        redirectUri: "/", // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
        postLogoutRedirectUri: "/", // Indicates the page to navigate after logout.
        navigateToLoginRequestUrl: false // If "true", will navigate back to the original request location before processing the auth code response.
    },
    cache: {
        cacheLocation: "localStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
                if (!containsPii && level === LogLevel.Error) {
                    console.error(message);
                }
            }
        }
    }
};

export const loginRequest = {
    scopes: windowInfo.scopes
};
